import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

/** Public footer links. Razorpay's website review looks for pricing, contact, refund, shipping, terms and privacy. */
export const FOOTER_LINKS: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/contact-us', label: 'Contact Us' },
  { to: '/cancellation-refund-policy', label: 'Cancellation & Refund' },
  { to: '/shipping-delivery-policy', label: 'Shipping & Delivery' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/prepaid-credits-policy', label: 'Prepaid Credits' },
  { to: '/acceptable-use-policy', label: 'Acceptable Use' },
  { to: '/cookies-policy', label: 'Cookies Policy' },
  { to: '/company', label: 'About Us' },
];

export function Footer() {
  return (
    <footer className="bg-surface-lowest border-t border-outline-variant/30 py-16">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8">
        <div>
          <BrandLogo variant="icon" size="lg" href="/" />
          <p className="text-sm text-on-surface-variant mt-2">© 2026 InviteCloud. Crafted for celebration.</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-3 sm:gap-x-8 justify-center md:justify-end max-w-3xl">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm text-on-surface-variant hover:text-primary underline-offset-4 hover:underline transition-all inline-flex items-center min-h-11 py-2 sm:py-1"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
